import { css } from '@/styled-system/css';

export const avatarContainerStyles = css.raw({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  display: 'flex',
  alignSelf: 'flex-end',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 'tighter',
  position: 'relative',
});
